import MarkerClusterGroup from "@changey/react-leaflet-markercluster";
import { divIcon, point } from "leaflet";
import React from "react";

const MarkerCluster = ({ children, ...props }) => {
    return (
        <MarkerClusterGroup chunkedLoading {...props} iconCreateFunction={createClusterCustomIcon}>
            {children}
        </MarkerClusterGroup>
    );
};

const createClusterCustomIcon = (cluster) => {
    return divIcon({
        html: cluster.getChildCount(),
        className: "map-icon__cluster",
        iconSize: point(30, 30, true),
    });
};

export default MarkerCluster;
